/**
 * OCPP URL fields (e.g. GetDiagnostics.location, GetLog.remoteLocation,
 * UpdateFirmware.firmware.location) are semantically XSD `anyURI`, which is far
 * more permissive than RFC 3986. ajv-formats' default `uri` format rejects
 * real-world CSMS URLs that a charge point must accept — notably an FTP
 * diagnostics-upload target whose password contains an unescaped `%`, e.g.
 *
 *   ftp://ftpuser-greenway-preprod:iRrkzj2h%%xvhCWe@ftp.uat.cpms.gway.cloud/files
 *
 * `%%` is not valid percent-encoding, so strict `uri` validation fails and the
 * simulator answers GetDiagnostics with a PropertyConstraintViolation CALLERROR
 * — over-strict vs the spec, and it blocks legitimate interop testing (a real
 * CP would accept the URL and attempt the upload).
 *
 * We override `uri` / `uri-reference` with an anyURI-style check (non-empty and
 * whitespace-free) so the vendored schemas stay byte-for-byte intact
 * (CLAUDE.md §4.5) while validation matches the spec's intent. Registered AFTER
 * `addFormats(ajv)` so it overrides the strict defaults.
 */
interface AjvLike {
  addFormat(name: string, format: (value: string) => boolean): unknown;
}

/** anyURI-style leniency: any non-empty, whitespace-free string passes. */
function isAnyUri(value: string): boolean {
  return value.length > 0 && !/\s/.test(value);
}

export function relaxOcppUriFormats(ajv: AjvLike): void {
  ajv.addFormat('uri', isAnyUri);
  ajv.addFormat('uri-reference', isAnyUri);
}
